import * as T from './loyaltyMembersTypes';
import type { LoyaltyMembersState } from './loyaltyMembersTypes';
import type { LoyaltyMembersAction } from './loyaltyMembersActions';

const initialState: LoyaltyMembersState = {
  members: [],
  activities: [],
  redemptions: [],
  loading: false,
  profileLoading: false,
  pagination: null,
  error: null,
};

export default function loyaltyMembersReducer(
  state = initialState,
  action: LoyaltyMembersAction,
): LoyaltyMembersState {
  switch (action.type) {
    case T.FETCH_MEMBERS_REQUEST:
      return { ...state, loading: true, error: null };
    case T.FETCH_MEMBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        members: action.payload.members,
        pagination: action.payload.pagination,
      };
    case T.FETCH_MEMBERS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case T.FETCH_MEMBER_PROFILE_REQUEST:
      return { ...state, profileLoading: true, error: null };
    case T.FETCH_MEMBER_PROFILE_SUCCESS: {
      const member = action.payload;
      const exists = state.members.some((m) => m.id === member.id);
      return {
        ...state,
        profileLoading: false,
        members: exists
          ? state.members.map((m) => (m.id === member.id ? member : m))
          : [...state.members, member],
      };
    }
    case T.FETCH_MEMBER_PROFILE_FAILURE:
      return { ...state, profileLoading: false, error: action.payload };

    case T.FETCH_MEMBER_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        activities: action.payload.activities,
        redemptions: action.payload.redemptions,
      };

    case T.ADJUST_POINTS_REQUEST:
      return { ...state, error: null };
    case T.ADJUST_POINTS_SUCCESS:
      return {
        ...state,
        members: state.members.map((m) =>
          m.id === action.payload.loyaltyCustomerId
            ? {
                ...m,
                currentBalance: Number.isFinite(action.payload.newBalance)
                  ? action.payload.newBalance
                  : m.currentBalance + action.payload.points,
                lifetimeEarned:
                  action.payload.points > 0
                    ? m.lifetimeEarned + Math.abs(action.payload.points)
                    : m.lifetimeEarned,
              }
            : m,
        ),
      };
    case T.ADJUST_POINTS_FAILURE:
      return { ...state, error: action.payload };

    case T.EXPORT_MEMBERS_REQUEST:
    case T.EXPORT_MEMBERS_SUCCESS:
    case T.EXPORT_MEMBERS_FAILURE:
      return state;

    // Optimistic update — apply on REQUEST, revert on REVERT
    case T.TOGGLE_NOTIFICATION_REQUEST:
      return {
        ...state,
        members: state.members.map((m) =>
          m.id === action.payload.memberId
            ? { ...m, notification_enabled: action.payload.enabled }
            : m,
        ),
      };
    case T.TOGGLE_NOTIFICATION_SUCCESS:
      return state;
    case T.TOGGLE_NOTIFICATION_FAILURE:
      return { ...state, error: action.payload };
    case T.TOGGLE_NOTIFICATION_REVERT:
      return {
        ...state,
        members: state.members.map((m) =>
          m.id === action.payload.memberId
            ? { ...m, notification_enabled: action.payload.enabled }
            : m,
        ),
      };

    default:
      return state;
  }
}
